import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SourcesContainer from '../../shared/SourcesContainer';
import SourceItem from '../../shared/SourceItem';
import styles from '../../styles.css';

const templates = [
  {
    id: '1',
    label: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.label.default"
        defaultMessage="Default"
      />
    ),
    icon: 'document',
    description: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.chooseSources.marcTemplates.desc.default"
        defaultMessage="MARC default template"
      />
    ),
    active: true,
    url: '/inventory/quick-marc/create-bib',
  },
];

function MarcTemplates({ setSourceUrl }) {
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);

  useEffect(() => {
    setSourceUrl(selectedTemplate.url);
  }, [selectedTemplate.url]);

  const renderTemplates = () => {
    return (
      <div className={styles.templates}>
        {templates.map((template, index) => (
          <SourceItem
            key={`marc-template-${template?.id}`}
            index={index}
            selectedTemplateId={selectedTemplate.id}
            setSelectedTemplate={setSelectedTemplate}
            sourceLabel={template.label}
            template={template}
          />
        ))}
      </div>
    );
  };

  return (
    <SourcesContainer
      selectedTemplate={selectedTemplate}
      templates={renderTemplates()}
      isLocalizedDesc={false}
    />
  );
}

MarcTemplates.propTypes = {
  setSourceUrl: PropTypes.func,
};

export default MarcTemplates;
